import React from "react"

type PageHeroProps = {
  eyebrow?: string
  headline: string
  intro?: string
  children?: React.ReactNode
}

export const PageHero = ({
  eyebrow,
  headline,
  intro,
  children,
}: PageHeroProps) => (
  <section className="text-gray-700 body-font">
    <div className="container mx-auto px-5 pt-10 pb-10 md:pt-16 md:pb-12">
      <div className="max-w-3xl">
        {eyebrow ? (
          <p className="text-sm uppercase tracking-wider text-purple-500 mb-3">
            {eyebrow}
          </p>
        ) : null}
        <h1 className="title-font text-3xl md:text-4xl font-medium text-gray-900 mb-4 leading-tight">
          {headline}
        </h1>
        {intro ? (
          <p className="text-base md:text-lg leading-relaxed text-gray-600">
            {intro}
          </p>
        ) : null}
        {children ? <div className="mt-6">{children}</div> : null}
      </div>
      <div className="mt-6">
        <div className="w-16 h-1 rounded-full bg-purple-500" />
      </div>
    </div>
  </section>
)
